<div class="modal z-50 fixed w-screen h-full top-0 left-0 flex items-center justify-center p-5 lg:p-0">
  <div class="modal-overlay fixed w-full h-full bg-gray-900 opacity-50"></div>
  <div class="bg-white w-full lg:max-w-screen-lg mx-auto rounded-lg shadow-xl z-50">
    <!-- style="height: 50vh" -->
    <div class="flex flex-col gap-3 lg:justify-between lg:flex-row h-5/6">
      <!-- Formulário -->
      <div class="w-full p-5">
        <form [formGroup]="formEditUsuarioAdmin">
          <p class="text-xs font-semibold tracking-wide text-chathams-blue uppercase mb-2">Dados Pessoais</p>
          <div class="grid w-full grid-cols-2 gap-4">
            <div class="form-group col-span-2">
              <label for="name" class="input-label">Nome*</label>
              <input type="text" class="form-input" formControlName="fullName" id="name" />
            </div>

            <div class="form-group">
              <label for="cpf" class="input-label">CPF*</label>
              <input
                type="text"
                class="form-input"
                formControlName="document"
                [showMaskTyped]="true"
                id="cpf"
                mask="000.000.000-00"
              />
            </div>

            <div class="form-group">
              <label for="email" class="input-label">E-mail*</label>
              <input type="email" class="form-input" formControlName="email" id="email" />
            </div>
          </div>

          <hr class="my-4 border-gray-200" />

          <p class="text-xs font-semibold tracking-wide text-chathams-blue uppercase mb-2">Acesso</p>
          <div class="grid w-full grid-cols-2 gap-4">
            <div class="form-group">
              <label for="perfil-acesso" class="input-label">Perfil de Acesso*</label>
              <ng-select
                notFoundText="Nenhum item encontrado"
                [items]="opcoesPerfilAcesso"
                [searchable]="true"
                placeholder="Perfil de Acesso"
                formControlName="adminUserProfileIds"
                bindLabel="description"
                bindValue="id"
                [multiple]="true"
                [closeOnSelect]="false"
              >
              </ng-select>
            </div>

            <div class="form-group">
              <label for="admin-role" class="input-label">Role*</label>
              <ng-select
                notFoundText="Nenhum item encontrado"
                [items]="opcoesAdminRole"
                [searchable]="true"
                placeholder="Role"
                formControlName="adminRole"
                bindLabel="label"
                bindValue="value"
                [multiple]="false"
              >
              </ng-select>
            </div>
          </div>

          <ng-container *ngIf="podeEscolherEmpresa">
            <hr class="my-4 border-gray-200" />

            <p class="text-xs font-semibold tracking-wide text-chathams-blue uppercase mb-2">Vínculo Institucional</p>
            <div class="grid w-full grid-cols-2 gap-4">
              <ng-container *isAllowed="[ERoleAdminString.Admin]">
                <div class="form-group">
                  <label for="tipo-conta" class="input-label">Tipo de Conta</label>
                  <ng-select
                    notFoundText="Nenhum item encontrado"
                    [items]="opcoesAccountRole"
                    [searchable]="true"
                    placeholder="Tipo de Conta"
                    formControlName="accountRole"
                    bindLabel="label"
                    bindValue="value"
                    [multiple]="false"
                    (change)="changeAccountRole()"
                  >
                  </ng-select>
                </div>

                <div class="form-group">
                  <label for="parceiro" class="input-label">Parceiro</label>
                  <ng-select
                    notFoundText="Nenhum item encontrado"
                    [items]="opcoesPartner"
                    [searchable]="true"
                    placeholder="Parceiro"
                    formControlName="partnerId"
                    bindLabel="name"
                    bindValue="id"
                    [multiple]="false"
                    (change)="changePartner()"
                  >
                  </ng-select>
                </div>
              </ng-container>

              <div class="form-group">
                <label for="empresa" class="input-label">Empresa</label>
                <!-- Limpar a empresa deixa o usuário só com o parceiro. -->
                <ng-select
                  class="com-limpar"
                  notFoundText="Nenhum item encontrado"
                  [items]="opcoesEmpresa"
                  [searchable]="true"
                  [clearable]="true"
                  placeholder="Empresa"
                  formControlName="companyId"
                  bindLabel="name"
                  bindValue="id"
                  [multiple]="false"
                >
                </ng-select>
              </div>
            </div>
          </ng-container>
        </form>
      </div>

      <!-- Menu Lateral -->
      <div
        class="relative flex flex-row justify-between gap-5 p-3 lg:px-10 sm:justify-start sm:gap-3 sm:flex-wrap lg:flex-col lg:justify-end bg-iceberg menu lg:h-auto sm:w-auto"
      >
        <button
          class="absolute w-12 h-10 rounded-sm lg:top-5 right-10 btn--secondary"
          routerLink="/dash/usuarios-admin"
        >
          X
        </button>

        <button
          *isAllowed="[ERoleAdminString.Admin, 'adminuser.update']"
          class="sm:px-2 lg:mb-5 btn btn--secondary"
          (click)="editarUsuarioAdmin()"
        >
          Salvar Cadastro
        </button>
      </div>
    </div>
  </div>
</div>
